export default {
  'introThanks': 'Merci de nous laisser votre avis. Celui-ci nous permettra de nous améliorer !',
  'customerFirstname': 'Prénom',
  'customerLastname': 'Nom de famille',
  'customerEmail': 'E-mail',
  'customerTitle': 'Titre',
  'visitFrom': 'Date d\'arrivée',
  'visitTo': 'Date de départ',
  'visitRoom': 'Numéro de chambre',
  'salutationOptionMr': 'Monsieur',
  'salutationOptionMrs': 'Madame',
  'salutationOptionFamily': 'Famille',
  'btnStart': 'Début',
  'thanksTitle': 'Merci beaucoup !',
  'thanksTextFinish': 'Les personnes pressées peuvent remplir le questionnaire dès maintenant ...',
  'thanksBtnFinish': 'Terminer',
  'thanksTextContinue': '... mais si vous avez encore quelques minutes à nous accorder, nous vous serons reconnaissants de bien vouloir répondre à quelques questions supplémentaires.',
  'thanksBtnContinue': 'Autres questions',
  'selectChooseOption': 'Veuillez choisir une option',
  'btnNext': 'Continuer',
  'btnSkip': 'Sauter',
  'btnFeedback': 'Commentaire',
  'selectorTextThanks': 'Super ! Merci pour votre aide !',
  'selectorTextSelect': 'Quelles sont les offres dont vous avez profité ?',
  'feedbackTitle': 'Votre commentaire à propos de ce sujet',
  'feedbackPositiveTitle': 'Qu\'est-ce qui était positif ?',
  'feedbackNegativeTitle': 'Qu\'est-ce qui était négatif ?',
  'smileyVeryHappy': 'Très satisfait',
  'smileyHappy': 'Satisfait',
  'smileyMedium': 'OK',
  'smileyUnhappy': 'Insatisfait',
  'smileyVeryUnhappy': 'Très insatisfait',
  'smileyNotScored': 'Non évalué',
  'validationMessageEmail': 'Veuillez entrer une adresse e-mail valide.',
  'validationMessageRequired': '"Champs obligatoires"',
  'txtAppStart': 'Charger le questionnaire',
  'selectorTitle': 'Utilisation de nos offres',
  'finalThanksTitle': 'Merci pour vos suggestions',
  'finalThanksHolidayCheckIntro': 'Pouvons-nous transmettre une partir de vos appréciations à HolidayCheck ?<br />Vous nous feriez une grande faveur ! À la page suivante, nous vous montrerons un résumé de vos données, que nous transférons avec votre accord à HolidayCheck.<br /><br />Il nous vous reste plus que quelques clics & quelques choses à compléter – Ensuite, c\'est fini.',
  'finalThanksHolidayCheckBtn': 'Afficher le résumé HolidayCheck',
  'pickDate': 'Choisir une date',
  'surveyFinishedTitle': 'Le questionnaire est terminé',
  'surveyAlreadyDone': 'Vous avez déjà participé à cette enquête, merci !',
  'legendPrimerPositive': 'Entièrement satisfait',
  'legendPrimerNegative': 'Très insatisfait',
  'hcTitle_recommendation': 'Recommanderiez-vous cet hôtel ?',
  'hcTitle_title': 'Comment s\'intitule le titre de votre avis ?',
  'hcTitle_text': 'Décrivez l\'hôtel en général.',
  'hcDescription_text': 'Décrivez votre première impression de l\'hôtel en 2-3 phrases. Était-il adapté à vos attentes par exemple ?',
  'hcFilledHint': 'Veuillez remplir les champs suivants.',
  'hcTitle_age': 'Quel âge avez-vous ?',
  'hcTitle_traveledWith': 'Avec qui voyagez-vous ?',
  'hcTitle_travelDuration': 'Durée du séjour ?',
  'hcOption_traveledWith_friends': 'Amis',
  'hcOption_traveledWith_family': 'Famille',
  'hcOption_traveledWith_couple': 'Couple',
  'hcOption_traveledWith_single': 'Seul',
  'hcOption_children_no': 'Aucun',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'plus que 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Très mauvais',
  'hcOption_ratingCostPerformance_bad': 'Plutôt mauvais',
  'hcOption_ratingCostPerformance_medium': 'Raisonnable',
  'hcOption_ratingCostPerformance_good': 'Plutôt bien',
  'hcOption_ratingCostPerformance_great': 'Très bien',
  'hcOption_travelReason_business': 'Travail',
  'hcOption_travelReason_city': 'Ville',
  'hcOption_travelReason_wellness': 'Spa',
  'hcOption_travelReason_winter': 'Hiver',
  'hcOption_travelReason_other': 'Autres',
  'hcOption_travelReason_beach': 'Plage',
  'hcOption_travelDuration_1-3 days': '1-3 jours',
  'hcOption_travelDuration_3-5 days': '3-5 jours',
  'hcOption_travelDuration_1 week': '1 semaine',
  'hcOption_travelDuration_2 weeks': '2 semaines',
  'hcOption_travelDuration_3 weeks': 'Plus que deux semaines',
  'hcCardTitle': 'Transfert de l\'avis à HolidayCheck',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'btnSubmit': 'Expédier',
  'requiredField': 'Champs obligatoires',
  'topicTitle': 'Autre thème ?',
  'topicHint': 'Sélectionnez le thème concernant lequel vous souhaitez laisser un commentaire',
  'txtSuggestFeedback': 'Votre commentaire serait super :-)',
  'txtFiguresPercent': 'Données en pourcentage',
  'txtImpress': 'Mentions légales',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Politique de confidentialité',
  'txtPrivacyConsent': 'J\'accepte que mes données dans cette enquête soient collectées et traitées afin d\'améliorer la qualité. Les données seront effacées 24 mois après l\'enquête. Vous pouvez révoquer votre consentement à tout moment à l\'adresse suivante <a href="mailto:%{mail}">%{mail}</a>. Vous trouverez des informations détaillées sur le traitement des données des utilisateurs dans notre <a href="%{link}" target="_blank">Politique de confidentialité</a>.',
  'txtPrivacyHint': 'J\'accepte que mon avis soit publié sur le site internet de la société et sur la page des avis <a href="%{link}" target="_blank">%{link}</a> avec mon sexe, mon nom abrégé, ma ville et la date à laquelle l\'avis a été publié. Je peux révoquer ce consentement à tout moment à l\'adresse suivante <a href="mailto:%{mail}">%{mail}</a>. L\'avis publié est alors supprimé.',
  'txtExample': 'Exemple',
  'txtSkip': 'Suivant',
  'txtPrivacyValidationHint': 'Nous ne pouvons pas traiter le texte sans autorisation',
  'btnDifferentTopic': 'Autre thème',
  'btnOK': 'OK'
}



// WEBPACK FOOTER //
// ./src/languages/fr.js